import styled from '@emotion/styled';

export const MapItemBorder = styled.div`
  :hover {
    border: 1px solid #00000020;
    border-radius: 5px;
  }
`;

export const Item = styled.div<{ opacity?: number; disable?: boolean }>`
  background: ${(props) => (props.disable ? '#C0C0C0' : '#FA505E')};
  opacity: ${(props) => (props.opacity ? props.opacity : props.disable ? '0.2' : '0.0')};
  content: ' ';
  border-radius: 5px;
  z-index: 1;
  -webkit-transition: opacity 1s;
  -moz-transition: opacity 1s;
  -o-transition: opacity 1s;
  transition: opacity 1s;
  height: 100%;
`;

export const Popup = styled.div<{ position: any; index: number; row: number }>`
  padding: 10px;
  box-shadow: 4px 5px 5px 0px rgba(0, 0, 0, 0.27);
  -webkit-box-shadow: 4px 5px 5px 0px rgba(0, 0, 0, 0.27);
  -moz-box-shadow: 4px 5px 5px 0px rgba(0, 0, 0, 0.27);
  position: absolute;
  height: auto;
  width: auto;
  pointer-events: none !important;
  background-color: white;
  user-select: none;
  left: ${(props) => (props.index > 4 ? 'unset' : props.position.x - 1 + 'px')};
  right: ${(props) => (props.index > 4 ? 'calc(100% - ' + props.position.x + 'px)' : 'unset')};
  top: ${(props) => (props.row > 2 ? 'unset' : props.position.y - 1 + 'px')};
  bottom: ${(props) => (props.row > 2 ? 'calc(100% - ' + props.position.y + 'px)' : 'unset')};
  z-index: 2;
`;
